import { useNavigate, useParams } from "react-router-dom";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { useEffect, useState } from "react";
import { getBasicObjectTypeLayer } from "../../../widgets/map/mapFeatures/layers";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { getObjectsOnMapPoint } from "../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

export const objectTypesDefaultFilters: any = {
    GeoMarkers: "GeoMarkerType in (2, 3)"
}

// Компонент для отображения карты объектов определенного типа без дополнительной логики, а также для отображения дополнительных разделов карты из конфигурации
export function MapObjectType() {
    let { objectTypeName }: any = useParams();
    const navigate = useNavigate();
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const [focusedLayer, setFocusedLayer] = useState<any>([])
    const { wmsServer, wmsVersion, workspace, mainLayer: AllRoadObjectsMapLayer } = getItemWebStorage('currentConfig')

    useEffect(() => {
        let mainLayers = null
        let name = null
        if (objectTypeName === 'AllRoadObjects') {
            mainLayers = AllRoadObjectsMapLayer
            name = `Карта «Все объекты»`
        } else {
            const objectTypes = getItemWebStorage('objectTypes')
            const objectType = objectTypes.find((objectType: any) => objectType.name === objectTypeName)
            const { mapLayer, caption } = objectType ?? {}
            name = `Карта «${caption}»`
            if (mapLayer) {
                mainLayers = mapLayer.replace('MA', 'MC')
            }
        }
        name && setMapTitle(name)
        if (!mainLayers) {
            navigate('/app/error')
        }
        let layerFilter = null
        if (objectTypesDefaultFilters.hasOwnProperty(objectTypeName)) {
            layerFilter = objectTypesDefaultFilters[objectTypeName]
        }
        const objectTypeLayer = getBasicObjectTypeLayer(mainLayers, wmsServer, wmsVersion, workspace, layerFilter)
        const additionalLayers = [objectTypeLayer]
        setFocusedLayer(objectTypeLayer)
        setAdditionalLayers(additionalLayers)
    }, [objectTypeName]);


    function applyMapObjectsFind(map: any) {
        let clickFunc = (event: any) => getObjectsOnMapPoint(event, objectTypeName, focusedLayer)
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "objectsFind",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={objectTypeName} type="map" />
            <div className="map-widget-with-toast">
                <MapWidget additionalLayers={additionalLayers} mapEventHandlers={mapEventHandlers} />
            </div>
        </>
    )
}
